import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const FRONTEND_RELEASE = 'stage2h-rc11';

// Admin-only release line: frontend label, backend label and backend source fingerprint.
export const BuildStamp = () => {
    const [b, setB] = useState(null);
    useEffect(() => {
        axios.get(`${API}/admin/build-info`, { withCredentials: true }).then(r => setB(r.data)).catch(() => setB(null));
    }, []);
    if (!b) return null;
    const mismatch = b.release !== FRONTEND_RELEASE;
    return (
        <div data-testid="build-stamp" className={`mt-6 text-[11px] font-mono ${mismatch ? 'text-red-400' : 'text-zinc-500'}`}>
            <span data-testid="build-stamp-frontend">screens {FRONTEND_RELEASE}</span>
            {' · '}<span data-testid="build-stamp-backend">server {b.release} (base {b.base})</span>
            {' · '}<span data-testid="build-stamp-fingerprint">fp {String(b.backend_fingerprint).slice(0, 12)}</span>
            {mismatch && <span data-testid="build-stamp-mismatch"> · screens and server differ</span>}
        </div>
    );
};
